var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "b-form",
        { on: { submit: _vm.onSubmit } },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-order",
                label: "Ordre",
                "label-for": "input-order",
              },
            },
            [
              _c("b-form-input", {
                attrs: { id: "input-order", type: "number", maxlength: "2" },
                model: {
                  value: _vm.form.order,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "order", $$v)
                  },
                  expression: "form.order",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-module-name",
                label: "Nom d'affichage du module",
                "label-for": "input-module-name",
              },
            },
            [
              _c("b-form-input", {
                attrs: { id: "input-module-name", type: "text" },
                model: {
                  value: _vm.form.theme_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "theme_name", $$v)
                  },
                  expression: "form.theme_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.module.pmo_data &&
          _vm.module.pmo_data.uri &&
          _vm.module.pmo_data.type &&
          _vm.module.pmo_data.type === "web"
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-params",
                    label: "Paramètres",
                    "label-for": "input-params",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { id: "input-module-params", type: "text" },
                    model: {
                      value: _vm.form.params_uri,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "params_uri", $$v)
                      },
                      expression: "form.params_uri",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-button", { attrs: { type: "submit", variant: "primary" } }, [
            _vm._v("Enregistrer"),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }